module.exports = __webpack_public_path__ + "img/candidate2.184091bf.jpg";